import { useAppQuery } from "~/hooks/useAppQuery"
import { getUserAgreement } from "../server/user-agreement.functions"

export const userAgreementQueryKey = ["profile", "user-agreement"] as const

export function useUserAgreement() {
  return useAppQuery({
    queryKey: userAgreementQueryKey,
    queryFn: () => getUserAgreement(),
    errorMessage: "Не удалось загрузить условия использования",
  })
}
